(function () {
  const $playerContainer = document.querySelector('div.trinity_player');

  if ($playerContainer !== null) {
      const $scriptEl = document.createElement('script');
      $scriptEl.src = 'https://trinitymedia.ai/player/trinity/2900004656/?pageURL=' + encodeURIComponent(window.location.href) + '&voiceId=' + $playerContainer.dataset.vid + '&poweredby=0';
      $playerContainer.appendChild($scriptEl);
  }

  window.addEventListener('message', (event) => {
      if (event.data?.type !== 'TRINITY_TTS') return;

      switch (event.data.value.action) {
          case 'playClicked':
          case 'pauseClicked':
          case 'resumed':
          case 'touchStart':
          case 'touchEnd':
          case 'onFirstQuartile':
          case 'onMidPoint':
          case 'onThirdQuartile':
          case 'onComplete':
              dataLayer.push({
                  'event': 'TrinityPlayerEvent', 'name': event.data.value.action
              });
              break;
      }
  });
})();